var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.886 5.115a6.376 6.376 0 0 1 6.376 6.376 6.354 6.354 0 0 1-1.964 4.6L16.001 26.44 5.517 15.904a6.35 6.35 0 0 1-1.778-4.413 6.376 6.376 0 0 1 12.262-2.452 6.377 6.377 0 0 1 5.886-3.924zm0-1.066A7.424 7.424 0 0 0 16 6.933a7.42 7.42 0 0 0-5.886-2.884c-4.104 0-7.442 3.339-7.442 7.442 0 1.928.737 3.758 2.075 5.152L16 27.952l11.053-11.108a7.368 7.368 0 0 0 2.275-5.352c0-4.104-3.339-7.442-7.442-7.442z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.48ca87e2da2b48c079ceea46d94530b9.svg";
export { ForwardRef as ReactComponent };